import { Flex, Separator, Text } from '@chakra-ui/react';

export const OrSeparator = ({ label }: { label: string }) => (
  <Flex align="center" gap="12px" my={{ base: 1, md: 2 }}>
    <Separator flex="1" borderColor="gray.200" />
    <Text fontSize="12.5px" color="gray.500" whiteSpace="nowrap">
      {label}
    </Text>
    <Separator flex="1" borderColor="gray.200" />
  </Flex>
);
